import { controls,grouped } from "../controls";
const account_vehicle_details = {
label: "Account Vehicle Details",
pageLabel: "Account Vehicle Details",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Vehicle Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "vehicle_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Vehicle Brand Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "vehicle_brand_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Vehicle Model Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "vehicle_model_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Dealer Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "dealer_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Valuator Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "valuator_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Engine Cc"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "engine_cc",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Chasis Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "chasis_number",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Ex Showroom Price"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "ex_showroom_price",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Sale Price"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "sale_price",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "License Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "license_number",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Vehicle Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "vehicle_number",maxlength:12}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Invoice Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "invoice_number",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Vehicle Type",star:false}),
...controls.oc({ tab: "general", c: "VehicleType", placeHolder: "Vehicle Type Code", name: "vehicle_type_code", isRequired:false,fastpath:"vehicle_types"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vehicle_type_display"}),
...controls.displayText({ tab: "general", label: "Vehicle Brand",star:false}),
...controls.oc({ tab: "general", c: "VehicleBrand", placeHolder: "Vehicle Brand Code", name: "vehicle_brand_code", isRequired:false,fastpath:"vehicle_brands"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vehicle_brand_display"}),
...controls.displayText({ tab: "general", label: "Vehicle Model",star:false}),
...controls.oc({ tab: "general", c: "VehicleModel", placeHolder: "Vehicle Model Code", name: "vehicle_model_code", isRequired:false,fastpath:"vehicle_models"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vehicle_model_display"}),
...controls.displayText({ tab: "general", label: "Vendor",star:false}),
...controls.oc({ tab: "general", c: "Vendor", placeHolder: "Vendor Code", name: "vendor_code", isRequired:false,fastpath:"vendors"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vendor_display"}),
...controls.displayText({ tab: "general", label: "Valuator",star:false}),
...controls.oc({ tab: "general", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", isRequired:false,fastpath:"valuators"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "valuator_display"}),
...controls.displayText({ tab: "general", label: "Engine Cc",star:true}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "engine_cc",isRequired:true,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Chasis Number",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "chasis_number",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Ex Showroom Price"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "ex_showroom_price",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sale Price"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "sale_price",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "License Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "license_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Vehicle Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "vehicle_number",isRequired:false,maxlength:12}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Invoice Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "invoice_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Vehicle Details",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Vehicle Type Id",accessor: "vehicle_type_id",},
{Header: "Vehicle Brand Id",accessor: "vehicle_brand_id",},
{Header: "Vehicle Model Id",accessor: "vehicle_model_id",},
{Header: "Dealer Id",accessor: "dealer_id",},
{Header: "Valuator Id",accessor: "valuator_id",},
{Header: "Engine Cc",accessor: "engine_cc",},
{Header: "Chasis Number",accessor: "chasis_number",},
{Header: "Ex Showroom Price",accessor: "ex_showroom_price",},
{Header: "Sale Price",accessor: "sale_price",},
{Header: "License Number",accessor: "license_number",},
{Header: "Vehicle Number",accessor: "vehicle_number",},
{Header: "Invoice Number",accessor: "invoice_number",},
]}};
export default account_vehicle_details;